import React from "react";
import { useIntl } from "react-intl";
import { actionModalMessages } from "../../../orchestrator.messages";

interface StringInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function StringInput({ value, onChange }: StringInputProps) {
  const intl = useIntl();

  return (
    <input
      type="text"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={intl.formatMessage(actionModalMessages.enterValue)}
      className="w-full border rounded px-3 py-2"
    />
  );
}
